export const VENUES = {
  THE_BULLWHEEL: "The Bullwheel",
  FOURTH_ACE: "Fourth Ace",
} as const;

export type Venue = keyof typeof VENUES;
export type VenueLabel = (typeof VENUES)[Venue];

// Helper function to get venue options for dropdowns
export const getVenueOptions = () => {
  return Object.entries(VENUES).map(([key, label]) => ({
    value: key as Venue,
    label,
  }));
};

// Helper to get venue label from key
export const getVenueLabel = (venue: Venue): VenueLabel => {
  return VENUES[venue];
};
